<template>
<div class="content">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName"><i class="lt"></i><i class="rt"></i>
    <el-tab-pane name="xjjhzd">
      <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 巡检计划制定 </span>
      <normalNav :parent="self">
        <button class="GreenSmBtn" @click="add">新增</button>
      </normalNav>
      <div class="searchForm1">
        <searchForm :items="items" :formPlus="form_xjjhzd" ref="searchForm_xjjhzd">
          <template slot="last">
            <el-form-item label="巡检部门" prop="dept_id">
              <searchCompany  :pId="form_xjjhzd.dept_id" @changeCompany="changeCompany" ref="searchCompany"></searchCompany>
            </el-form-item>
          </template>
        </searchForm>
      </div>
      <div class="tableWrapper">
        <easyTable apiUrl="operation/program/findAll" :parent="self" :config="config" :other="other" ref="table_xjjhzd">
          <template slot="last">
            <el-table-column label="操作" width="300" align="center">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="stop(scope.row)" v-if="scope.row.is_open==1">停用</el-link>
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="go(scope.row)" v-if="scope.row.is_open==0">启用</el-link>
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="edit(scope.row)" :disabled="scope.row.is_open==1">编辑</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index, scope.row)" :disabled="scope.row.is_open==1">删除</el-link>
              </template>
            </el-table-column>
          </template>
        </easyTable>
      </div>

      <add :form="lookForm" :pVisible="addDialogVisible" @closeAdd="closeAdd" @success="success" ref="add"></add>

      <el-dialog class="lookDialog" title="预案详情" :visible.sync="lookDialogVisible" :close-on-click-modal="false" v-loading="lookLoading">
        <section class="list" v-if="!lookLoading">
          <ul>
            <li>预案名称：{{oLook.name}}</li>
            <li>最大巡检时长(小时)：{{oLook.max_time}}</li>
            <li>最小巡检时长(小时)：{{oLook.min_time}}</li>
          </ul>
          <ul>
            <li>巡检间隔时间(分钟)：{{oLook.interval_time}}</li>
            <li>巡检部门：{{oLook.deptName}}</li>
            <li>是否顺序巡检：{{oLook.sequence == 0 ? "是" : "否"}}</li>
          </ul>
        </section>
        <header class="point"><span>点位详情</span></header>
        <easyTable :pData="{
    data:oLook.list,
    nTotal:oLook.list.length
  }" :config="col" v-if="!lookLoading">
          <el-table-column label="序号" width="100" align="center" slot="first">
            <template slot-scope="scope">
              {{scope.$index}}
            </template>
          </el-table-column>
        </easyTable>
      </el-dialog>

    </el-tab-pane>
  </el-tabs>
<el-dialog
  title="选择设备"
  :visible.sync="dialogVisible"
  width="80%">
          <div class="tableWapper deviceTable">
            <div class="tablehead">
              <div>
          <el-form ref="searchForm_jsgl">
            <el-form-item label="设备名称">
              <el-input placeholder="请输入设备名称" v-model="seefrom.deviceName"></el-input>
            </el-form-item>
            <el-form-item label="设备编码">
              <el-input placeholder="请输入设备编码" v-model="seefrom.device_mark"></el-input>
            </el-form-item>
          </el-form>

              </div>
              <div class="normalNav zaddBtn">
              <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
              <button class="OrangeSmBtn" @click="reset">重置</button>
              </div>
            </div>
          <el-table :data="tableData2" style="width: 100%" class="stripeTable" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config2" :key='prop.toString()'>
            </el-table-column>
            <el-table-column
                  label="操作"
                  width="100"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">选择</el-button>
                  </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination v-if="flagshow" layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal2">
            </el-pagination>
          </div>
        </div>
</el-dialog>
</div>
</template>

<script>
import {
  dt,
  obj2urlsp
} from "utils";

export default {
  data() {
    return {
      tabName: 'xjjhzd',
      show: false,
      items: [{
        type: "input",
        prop: "name",
        label: "计划名称",
        placeholder: "",
      }],
      form_xjjhzd: {},
      oLook: {},
      lookLoading: true,
      lookDialogVisible: false,
      addDialogVisible: false,
      dialogVisible:false,
      lookForm: null,
      data: {},
      other: {},
      tableData: [],
      tableData2:[],
      pagesize: 3,
      nTotal2: 0,
      currentPage: 1,
      flagshow:true,
      seefrom:{
        deviceName: "",
        device_mark: "",
      },
      config2: [
        {
          prop: "deviceName",
          label: "设备名称",
        },
        {
          prop: "device_mark",
          label: "设备编码",
        },
        {
          prop: "region",
          label: "所属区域",
        },
        {
          prop: "model",
          label: "设备型号",
        },
        {
          prop: "factory",
          label: "生产厂商",
        },
        {
          prop: "deviceStatusName",
          label: "设备状态",
        },
        {
          prop: "systemName",
          label: "应用系统",
        },
      ],
    };
  },
  watch:{
    dialogVisible(){
      this.getTableList();
    }
  },
  computed: {
    self() {
      return this;
    },
    col() {
      return [{
          label: '巡检点',
          prop: 'name'
        },
        {
          label: '区域',
          prop: 'areaName'
        },
        {
          label: '巡检顺序',
          prop: 'sequence'
        }
      ]
    },
    config() {
      return [{
        prop: 'name',
        label: '计划名称'
      }, {
        prop: 'planName',
        label: '预案'
      }, {
        prop: 'deptName',
        label: '巡检部门'
      }, {
        prop: (row, column) => row.type == 0 ? "收工回查" : "日常巡检",
        label: '计划类型'
      }, {
        prop: (row, column) => row.period == 0 ? "每日" : row.period == 1 ? "每周" : "每月",
        label: '巡检周期'
      }, {
        prop: 'number',
        label: '周期内巡检次数'
      }, {
        prop: 'checkCounts',
        label: '巡检点位数'
      }];
    },
  },
  methods: {
    reset_xjjhzd(fn) {
      fn();
      this.form_xjjhzd = {};
      this.$refs['searchCompany'].company = '';
    },
    search_xjjhzd(fn) {
      fn();
    },
    edit(row) {
      this.lookForm = row;
      this.addDialogVisible = true;
    },
    go(row) {
      this.$axiospost('/operation/program/updateIsOpen', obj2urlsp({
        id: row.id,
        is_open: 1
      })).then(res => {
        this.$refs['table_xjjhzd'].getData();
        this.$message({
          duration: 1000,
          message: '启用成功',
          type: 'success'
        });
      })
    },
    stop(row) {
      this.$axiospost('/operation/program/updateIsOpen', obj2urlsp({
        id: row.id,
        is_open: 0
      })).then(res => {
        this.$refs['table_xjjhzd'].getData();
        this.$message({
          duration: 1000,
          message: '停用成功',
          type: 'success'
        });
      })
    },
    add() {
      this.addDialogVisible = true;
    },
    closeAdd() {
      this.addDialogVisible = false;
      this.lookForm = null;
    },
    success() {
      this.addDialogVisible = false;
      this.lookForm = null;
      this.$refs['table_xjjhzd'].getData();
    },
    look(data) {
      this.lookLoading = true;
      this.lookDialogVisible = true;
      this.$axiosget('operation/plan/findInfo', {
        params: {
          id: data.id
        }
      }).then(res => {
        this.oLook = res.data;
        this.lookLoading = false;
      })
    },
    changeCompany(dept_id) {
      this.$set(this.form_xjjhzd, "dept_id", dept_id);
    },
    deleteMsg(index, row) {
      this.$confirm("确定删除计划?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("/operation/program/delete", {
            params: {
              "id": row.id
            }
          })
          .then(res => {
            this.$message({
              duration: 1000,
              message: '删除成功',
              type: 'success'
            });
            this.$refs['table_xjjhzd'].getData();
          })
      });
    },
    getTableList() {
      this.$axiosget("operation/device/list", {
        params: { pageSize: 10, pageNum: this.currentPage,...this.seefrom},
      }).then(res => {
        this.tableData2 = res.data.data.deviceList;
        this.nTotal2 = res.data.data.total;
        this.flagshow = true;
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableList();
    },
    subSeefrom() {
      this.flagshow = false;
      this.getTableList();
    },
    reset() {
      this.seefrom.deviceName = "";
      this.seefrom.device_mark = "";
    },
    handleClick(row){
      this.dialogVisible=false
      this.$refs.add.form1.device_id=row.deviceId
      this.$refs.add.form1.device_name=row.deviceName
      this.$refs.add.$forceUpdate()
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    add: () => import("./add"),
    searchCompany: () => import("public/searchCompany")
  },
  mounted() {

    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });

    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #FFF;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom:1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.tablehead{
  display: flex;
  justify-content:space-between;
  .el-form{
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/xunjian/xunjianPlan/index.vue